import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { Table } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getStateList } from "../../redux/actions/indexActions";
import { toast } from "react-toastify";

const EditPlace = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    state_id: "",
    city_id: 0,
    town_id: 0,
  });
  const [stateData, setStateData] = useState([]);
  const {
    AuthReducer: { auth },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state)
  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ! ")) {
      axios.delete(`/api/admin/v1/destination/${id}`, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      }).then((res) => {
        toast.success(res.data.message);
      }).catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  useEffect(() => {
    axios(`/api/admin/v1/edit-destination/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    }).then((res) => {
      setFormData({
        state_id: res.data?.destinations?.state_id,
        city_id: res.data?.destinations?.city_id,
        town_id: res.data?.destinations?.town_id,
      });

      setStateData(res.data?.destinations);
      console.log(stateData);
    }).catch((err) => console.log(err));
  }, [auth]);

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-10">
          <h4 className="text-white">Edit Destination</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>State</th>
                  <th> City</th>
                  <th>Town Name</th>
                  {allowedPermissions?.some?.(
                    (item) =>
                      item?.permission?.moduleType === "SUBSUBCATEGORIES" &&
                      (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")
                  ) && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {stateData?.length === 0 ? (
                  <tr>
                    <td colSpan="12">No data found</td>
                  </tr>
                ) : (<>
                  {stateData?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1}</th>
                        <td>{item?.state?.state_name}</td>
                        <td>{item?.city?.city_name}</td>
                        <td>{item?.town?.town_name}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBSUBCATEGORIES" &&
                                item?.permission?.permission === "edit"
                            ) && (

                                <Link to={`/edit-destination-details/${item.id}`}>
                                  <AiOutlineEdit size={22} className="text-warning me-3" />
                                </Link>

                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBSUBCATEGORIES" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete size={22} className="text-danger" onClick={() => handleDel(item.id)} />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPlace;
